<div class="font-default flex text-3xl select-none">
  <span class="ease-out-back inline-block py-4 transition-all" [class]="appearanceTw() + ' ' + tw()">
    {{ content() }}
  </span>
</div>
